import DOMPurify from "dompurify";
import { normalizeNbsp } from "../../../helpers/stringHelpers";

const ALLOWED_TAGS = [
  "p", "br",
  "strong", "b", "em", "i", "u",
  "ul", "ol", "li",
  "h1", "h2", "h3", "h4",
  "span",
];

const ALLOWED_ATTR = ["style", "data-list"];

interface Props {
  html: string;
}

export const CommentsHTML = ({ html }: Props) => {
  const clean = DOMPurify.sanitize(normalizeNbsp(html), {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
  });

  return (
    <div
      className="comments-html"
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
};
